
import './App.scss';
import { Routes, Route, useSearchParams } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Results from './components/Results';
import Admin from './components/admin/Admin';
import Entries from './components/entries/Entries';
import { useEffect, useRef, useState } from 'react';
import { retrieveUser, retrieveWeeks, retrieveUsers, setApiClearTokenFunction } from './api/api';
import DebtModal from './components/auth/DebtModal';
import LoginModal from './components/auth/LoginModal';
import RegisterModal from './components/auth/RegisterModal';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RequestPasswordResetModal from './components/auth/RequestPasswordResetModal';
import ResetPasswordModal from './components/auth/ResetPasswordModal';

function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  setApiClearTokenFunction(() => setToken(''));
  const [user, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [weeks, setWeeks] = useState([]);

  const [showDebtModal, setShowDebtModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRequestPasswordResetModal, setShowRequestPasswordResetModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  // const suppressAnnouncement = true
  const suppressAnnouncement = showDebtModal || showLoginModal || showRequestPasswordResetModal || showResetPasswordModal || showRegisterModal;

  const [nextPage, setNextPage] = useState('');
  const resetToken = useRef('');

  useEffect(() => {
    const rt = searchParams.get("rt");
    if (rt) {
      resetToken.current = rt;
      setShowResetPasswordModal(true);
      searchParams.delete("rt");
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (token) {
      const isLogin = localStorage.getItem('token') === null;
      localStorage.setItem('token', token);
      retrieveWeeks().then(weeks => {
        setWeeks(weeks);
      }).catch(() => {
        console.log('Failed to retrieve weeks for the season');
      });
      retrieveUsers().then(users => {
        setUsers(users);
      }).catch(() => {
        console.log('Failed to retrieve users');
      });
      retrieveUser().then(user => {
        setUser(user);
        setShowDebtModal(isLogin && user.debt > 0);
      }).catch(() => {
        console.log('Failed to retrieve user info');
      });
    } else {
      setUser(null);
      localStorage.removeItem('token');
    }
  }, [token]);

  return (
    <div className="App">
      <Header user={user} setToken={setToken} setShowLoginModal={setShowLoginModal} />
      <Routes>
        <Route path="/" element={<Home user={user} setNextPage={setNextPage} setShowLogin={setShowLoginModal} suppressAnnouncement={suppressAnnouncement} />} />
        <Route path="/results" element={<Results users={users} weeks={weeks} />} />
        <Route path="/entries" element={<Entries user={user} setUser={setUser} weeks={weeks} setWeeks={setWeeks} />} />
        <Route path="/admin" element={<Admin user={user} setUser={setUser} users={users} setUsers={setUsers} weeks={weeks} />} />
      </Routes>
      <DebtModal user={user} show={showDebtModal} setShow={setShowDebtModal} />
      <LoginModal show={showLoginModal} setShow={setShowLoginModal} setShowRegister={setShowRegisterModal} setToken={setToken} setShowRequestPasswordResetModal={setShowRequestPasswordResetModal} nextPage={nextPage} setNextPage={setNextPage} />
      <RegisterModal show={showRegisterModal} setShow={setShowRegisterModal} setToken={setToken} nextPage={nextPage} setNextPage={setNextPage} />
      <RequestPasswordResetModal show={showRequestPasswordResetModal} setShow={setShowRequestPasswordResetModal} />
      <ResetPasswordModal show={showResetPasswordModal} setShow={setShowResetPasswordModal} resetToken={resetToken} setToken={setToken} />
      <ToastContainer theme={'colored'} position={'bottom-right'}/>
    </div>
  );
}

export default App;
